export default __webpack_public_path__ + "static/media/380.5872963d.png";